import type { ReactNode } from "react";

interface Props {
  when: boolean;
  children: ReactNode;
}

export const ShowWhen = ({ when, children }: Props) => (when ? children : null);
